<template>
  <v-container 
    class="pa-0" 
    fluid="fluid" 
    grid-list-md="grid-list-md"
  >
    <v-row>
      <v-col cols="12">
        <h1 class="text-center font-weight-light mb-2">
          Thống kê giá cả thị trường
        </h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="2">
        <v-select
          v-model="selectedGroup"
          :items="groups"
          item-text="name"
          item-value="id"
          label="Nhóm giá"
          @change="getTypes"
          outlined
          return-object
          hide-details
          clearable
          dense
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-select
          v-model="selectedType"
          :items="types"
          item-text="name"
          item-value="id"
          label="Loại giá"
          outlined
          return-object
          hide-details
          clearable
          dense
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          v-model="tuNgay"
          label="Từ ngày"
          placeholder="dd/mm/yyyy"
          v-mask="'##/##/####'"
          outlined
          dense
        />
      </v-col>
      <v-col cols="12" md="2">
        <v-text-field
          v-model="denNgay"
          label="Đến ngày"
          placeholder="dd/mm/yyyy"
          v-mask="'##/##/####'"
          outlined
          dense
        />
      </v-col>
      <v-col cols="12" md="4">
        <v-btn block color="info" @click="initialize">Xem</v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="items"
          :hide-default-footer="true"
          disable-pagination
          hide-default-header
          :loading="loading"
        >
          <template v-slot:header="{ props }">
            <th v-for="(head, idx) in props.headers" 
              :key="`head${idx}`"
              class="table-header">
              {{ head.text.toUpperCase() }}
            </th>
          </template>
          <template v-slot:item.chart={item}>
            <v-sparkline
              :value="item.chart"
              :gradient="gradient"
              :smooth="radius || false"
              :padding="padding"
              :line-width="width"
              :stroke-linecap="lineCap"
              :gradient-direction="gradientDirection"
              :fill="fill"
              :type="type"
              :auto-line-width="autoLineWidth"
              auto-draw
            />
          </template>
          <template v-slot:item.actions="{ item }">
            <v-btn
              color="pink"
              text
              @click="view(item)"
            >
              Chi tiết
            </v-btn>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <v-dialog
      v-model="detailDialog"
      max-width="500px"
    >
      <v-card v-if="detailItem">
        <v-card-title>
          {{detailItem.name}}
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-sparkline
              :value="detailItem.chart"
              :gradient="gradient"
              :smooth="radius || false"
              :padding="padding"
              :line-width="width"
              :stroke-linecap="lineCap"
              :gradient-direction="gradientDirection"
              :fill="fill"
              :type="type"
              :auto-line-width="autoLineWidth"
              auto-draw
            />
          </v-row>
          <v-row>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left" 
                      v-for="(date, idx) in detailItem.date"
                      :key="`da${idx}`">
                      {{date}}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="text-left" 
                      v-for="(sl, idx) in detailItem.chart"
                      :key="`sl${idx}`">
                      {{sl | currency}}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="pink"
            text
            @click="detailDialog = false"
          >
            Đóng lại
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
  const gradients = [
    ["#222"],
    ["#42b3f4"],
    ["red", "orange", "yellow"],
    ["purple", "violet"],
    ["#00c6ff", "#F0F", "#FF0"],
    ["#f72047", "#ffd200", "#1feaea"],
  ];
  export default {
    data () {
      return {
        loading: false,
        detailDialog: false,
        detailItem: null,
        width: 2,
        radius: 10,
        padding: 8,
        lineCap: "round",
        gradient: gradients[5],
        value: [],
        gradientDirection: "top",
        gradients: gradients,
        fill: false,
        type: "trend",
        autoLineWidth: false,
        groups: [],
        selectedGroup: null,
        types: [],
        selectedType: null,
        items: [],
        headers: [
          { text: "Mặt hàng", value: "name", sortable: false },
          { text: "Đồ thị", value: "chart", sortable: false },
          { 
            align: 'right', 
            text: 'Thao tác', 
            value: 'actions', 
            sortable: false 
          },
        ],
        tuNgay: null,
        denNgay: null
      }
    },
    mounted () {
      this.initialize();
      this.getGroups();
    },
    methods: {
      getGroups() {
        axios.get("api/v1/market-prod-groups")
          .then(response => {
            this.groups = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      getTypes(){
        this.types = [];
        if(!this.selectedGroup)
          return false;
        axios.get(`api/v1/market-prod-types-by-group/${this.selectedGroup.id}`)
          .then(response => {
            this.types = response.data;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      initialize () {
        this.loading = true;
        let group = null, 
        type = null;
        if(this.selectedGroup){
          group = this.selectedGroup.id;
        }
        if(this.selectedType){
          type = this.selectedType.id;
        }
        let request = {
          params: {
            group: group,
            type: type,
            from: this.tuNgay,
            to: this.denNgay
          }
        };
        axios.get("api/v1/get-stat", request)
          .then(response => {
            let arr = [];
            response.data.forEach(function(value, index){
              let found = arr.find(element => element.name === value.name);
              let avg_price = value.avg_price ? parseInt(value.avg_price) : 0;
              if(found){
                found.chart.push(avg_price);
                found.date.push(value.ngay_cap_nhat);
              } else {
                arr.push({
                  name: value.name,
                  date: [value.ngay_cap_nhat],
                  chart: [avg_price]
                });
              }

            })
            this.items = arr;
            this.loading = false;
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      view(item){
        this.detailDialog = true;
        this.detailItem = item;
      }
    }
  }
</script>

<style>
td svg{
  width: 160px;
}
.table-header{
  background: #b3b3b3;
  padding: 10px;
  color: #fff;
  text-align: center;
}
</style>